import { Routes } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
  {
    path: 'page',
    loadChildren: () => import('../../pages/full-pages/full-pages.module').then(m => m.FullPagesModule)
  },
  {
    path: 'cadastro',
    loadChildren: () => import('../../pages/rf/cadastro/cadastro.module').then(m => m.CadastroModule)
  },
  {
    path: 'cadastro-grupo',
    loadChildren: () => import('../../pages/rf/cadastro-usuario-grupo/cadastro-usuario-grupo.module').then(m => m.CadastroUsuarioGrupoModule)
  },
  {
    path: 'cadastro-player',
    loadChildren: () => import('../../pages/rf/cadastro-usuario-player/cadastro-usuario-player.module').then(m => m.CadastroUsuarioPlayerModule)
  },
  {
    path: 'administrativo',
    loadChildren: () => import('../../pages/rf/administrativo/administrativo.module').then(m => m.AdministrativoModule)
  },
];
